import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const ChatIcon = ({
  width = 48,
  color = 'foraBlue',
  marginRight,
  marginLeft,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
      <g fill={getSemanticTextColor(color)} fillRule="evenodd">
        <path
          d="M59.861 46.92c1.85-3.264 2.995-6.981 2.995-11.004 0-9.37-5.747-17.38-13.905-20.743.871 2.645 1.352 5.455 1.352 8.387 0 14.848-12.033 26.885-26.876 26.894 4.117 4.804 10.152 7.91 16.98 7.91 4.032 0 7.763-1.149 11.036-3.012l11.413 2.99-2.995-11.422z"
          transform="translate(8.786 10.5)"
        />
        <path
          d="M33.673 17.654c0 1.239-1.01 2.244-2.245 2.244H13.469c-1.239 0-2.245-1.005-2.245-2.244 0-1.24 1.006-2.245 2.245-2.245h17.959c1.235 0 2.245 1.005 2.245 2.245M25.9 28.54H13.47c-1.239 0-2.245-1.006-2.245-2.245s1.006-2.245 2.245-2.245h12.432c1.24 0 2.245 1.006 2.245 2.245 0 1.24-1.006 2.245-2.245 2.245M22.45 0C10.048 0 0 10.052 0 22.449c0 4.018 1.14 7.74 2.99 11.004L0 44.875l11.408-2.99c3.273 1.863 7.004 3.012 11.04 3.012 12.397 0 22.45-10.052 22.45-22.448C44.897 10.052 34.844 0 22.447 0"
          transform="translate(8.786 10.5)"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
